import { memo } from "react";
import { cn } from "./cn";

interface SwitchProps {
  checked: boolean;
  onChange(checked: boolean): void;
  label: string;
  hint?: string;
  className?: string;
}

export const Switch = memo(function Switch({
  checked,
  onChange,
  label,
  hint,
  className,
}: SwitchProps) {
  return (
    <label
      className={cn(
        "flex cursor-pointer items-start justify-between gap-3 rounded-lg border border-white/[0.05] bg-surface-2/40 px-3 py-2.5 transition hover:border-white/10",
        className,
      )}
    >
      <span className="flex flex-col gap-0.5 text-sm">
        <span className="font-medium text-fg-strong">{label}</span>
        {hint ? <span className="text-xs text-fg-subtle">{hint}</span> : null}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={cn(
          "focus-ring relative inline-flex h-6 w-10 flex-none items-center rounded-full border border-white/10 transition",
          checked ? "bg-blue-500/70" : "bg-surface-3/80",
        )}
      >
        <span
          className={cn(
            "inline-block h-4 w-4 transform rounded-full bg-white shadow transition",
            checked ? "translate-x-5" : "translate-x-1",
          )}
        />
      </button>
    </label>
  );
});
